import React, { useState, useEffect } from 'react'
import { Box, Paper, Title, Modal, Text } from '@mantine/core'
import { getOrderInvoiceNumber, generateOrderInvoiceNumber } from '../../../../services/orders'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import OrderInvoiceNumberTable from './LayoutHelper/OrderInvoiceNumberTable'
import FormAdjustInvoiceNumber from './Form/FormAdjustInvoiceNumber'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import { generateInvoiceNumber } from '../../../ui/Prompt/generateInvoiceNumber'

const labelTable = [
  {
    label: 'Supplier Name',
    width: 300
  },
  {
    label: 'Invoice Number',
    width: 300
  },
  {
    label: 'Warehouse Name',
    width: 300
  },
  {
    label: 'Tracking Code Per Supplier',
    width: 'auto'
  },
  {
    label: 'Courier Name',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const defaultInvoiceAcn = [
  {
    name: 'AsiaCommerce',
    invoice_code: '-',
    tracking_code: '-',
    courier_name: '-'
  }
]

const OrderInvoicesDetails = () => {
  const { isLoadingOrderItems, dataOrderItems } = useSelector(state => state.order_items)
  const { summary } = useSelector(state => state.order_detail)
  const params = useParams()
  const orderId = params.order_id
  const [loadingInvoice, setLoadingInvoice] = useState(true)
  const [invoiceNumberList, setInvoiceNumberList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)


  const handleGetOrderInvoiceNumber = async () => {
    setLoadingInvoice(true)
    const params = {
      'filter[order_id][is]': orderId,
    }
    try {
      const response = await getOrderInvoiceNumber(params)

      const filterSupplierItems = dataOrderItems.filter((val) => val.supplierId)
      const filterDuplicateSupplier = filterSupplierItems.reduce((result, item) => {
        const removed = result.filter((val) => val.supplierId !== item.supplierId)
        return [...removed, item]
      }, [])

      const remapDataSupplierItems = filterDuplicateSupplier.map((val) => {
        return {
          supplier_id: Number(val.supplierId),
          supplier_name: val.supplierName
        }
      })

      if (response.success) {

        const dataInvoice = response.data
        const remapDataInvoice = dataInvoice.map((val) => {
          return val.attributes
        })
        const invoiceData = remapDataInvoice.reduce((result, value) => ({...result,[value.supplier_id]: value }), {})

        const remapData = remapDataSupplierItems.map((val, index) => {
          let data = {}

          const findInvoice = invoiceData[val.supplier_id]
          if (findInvoice) {
            data = {
              id: findInvoice.id,
              supplier_id: val.supplier_id,
              name: val.supplier_name,
              invoice_code: findInvoice.invoice_code,
              tracking_code: findInvoice.tracking_code,
              courier_name: findInvoice.courier_name
            }
          } else {
            data = {
              id: null,
              supplier_id: val.supplier_id,
              name: val.supplier_name,
              invoice_code: null,
              tracking_code: null,
              courier_name: null
            }
          }
          return data
        })

        setInvoiceNumberList(remapData)
      } else {

        const remapData = remapDataSupplierItems.map((val, index) => {
          return {
            supplier_id: val.supplier_id,
            name: val.supplier_name,
            invoice_code: null,
            tracking_code: null,
            courier_name: null
          }
        })
        
        setInvoiceNumberList(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingInvoice(false)
    }
  }

  useEffect(() => {
    handleGetOrderInvoiceNumber()
    // eslint-disable-next-line
  },[orderId])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    generate: (val) => {
      const payload = {
        supplier_id: val.supplier_id,
        order_id: orderId,
        invoice_code: `ALI/${summary.orderCode}/${val.supplier_id}`
      }
      generateInvoiceNumber(val.name, generateOrderInvoiceNumber, payload, handleGetOrderInvoiceNumber)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={20}>
        <Paper shadow="sm" withBorder p='md' mb={20}>
          <Title size={16} fw={500}>Invoice Number</Title>
          <Box my={10}>
            <OrderInvoiceNumberTable label={labelTable} data={defaultInvoiceAcn} />
          </Box>
        </Paper>
        <Paper shadow="sm" withBorder p='md' mb={20}>
          <Title size={16} fw={500}>Invoice Number Per Supplier</Title>
          <Box my={10}>
            {isLoadingOrderItems || loadingInvoice ? <LoadingData /> : invoiceNumberList.length > 0 ? <OrderInvoiceNumberTable label={labelTable} data={invoiceNumberList} actionMethod={handleAction} /> : <NoData />}
          </Box>
        </Paper>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>Update Payment Method</Text>} withCloseButton={false}>
        <FormAdjustInvoiceNumber dataInvoice={detailData} onCloseForm={onCloseModalForm} reloadList={handleGetOrderInvoiceNumber} />
      </Modal>
    </Box>
    
  )
}

export default OrderInvoicesDetails